import { Routes } from '@angular/router';
import { environment } from '@env';
import { RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha-2';

export const routes: Routes = [
  {
    loadComponent: () => import('@pages/home/home.component').then(c => c.HomeComponent),
    providers: [{ provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.captcha }],
    path: '',
    title: 'Puntos Colombia',
  },
  {
    loadComponent: () => import('@pages/home/home.component').then(c => c.HomeComponent),
    providers: [{ provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.captcha }],
    path: ':id/:hash',
    title: 'Puntos Colombia',
  },
];
